<style lang="scss">
.tabbar-edit {
  // @include border-shadow();
  // padding: 20px 15px;
  // border-radius: 6px;
  width: 300px;
  background: #fff;
  &-hd {
    display: flex;
    justify-content: space-between;
    line-height: 22px;
    .title {
      color: #333;
      font-weight: 600;
    }
    .desc {
      font-size: 13px;
      color: $color-hint-text;
      cursor: default;
    }
  }
  &-bd {
    margin-top: 10px;
    .bd-field {
      display: flex;
      align-items: center;
      &:nth-child(2) {
        .label {
          position: relative;
          top: -6px;
        }
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
    .label {
      font-size: 13px;
      width: 60px;
    }
    .field {
      .desc {
        font-size: 12px;
        color: $color-hint-text;
      }
    }
  }
  &-ft {
    text-align: right;
    margin-top: 10px;
  }
  .btn-edit {
    color: #409eff;
  }
  .img-wrap {
    display: flex;
  }
  .img-con-picker {
    width: 56px;
    height: 56px;
    background: #555;
    border-radius: 6px;
    margin-right: 10px;
    position: relative;
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    &:hover {
      span {
        display: block;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba($color: #555, $alpha: 0.3);
      }
    }
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 12px;
      display: none;
      z-index: 100;
    }
  }
  .btn-edit {
    color: #409eff;
    cursor: default;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>

<template>
  <div class="tabbar-edit">
    <div class="tabbar-edit-hd">
      <span class="title">编辑导航</span>
      <span
        :class="{
          'desc': true,
          'btn-edit':
            label != value.default ||
            (iconHighlight && iconHighlight != defaultHighIcon) ||
            (icon && icon != defaultIcon)
        }"
        @click="
          reInitVal(
            label != value.default ||
              (iconHighlight && iconHighlight != defaultHighIcon) ||
              (icon && icon != defaultIcon)
          )
        "
      >恢复默认</span>
    </div>
    <div class="tabbar-edit-bd">
      <div class="bd-field">
        <div class="label">
          导航名称
        </div>
        <div class="field">
          <el-input
            v-model="label"
            size="small"
            placeholder="请输入内容"
            maxlength="5"
            show-word-limit
          />
        </div>
      </div>
      <div class="bd-field">
        <div class="label">
          高亮/图标
        </div>
        <div class="field">
          <div class="desc">
            建议尺寸100px*100px
          </div>
          <div class="img-wrap">
            <div
              class="img-con-picker"
              :style="{ backgroundImage: `url(${iconHighlight || defaultHighIcon})` }"
              @click="handleClickChangeImage(1)"
            >
              <span>替换</span>
            </div>
            <div
              class="img-con-picker"
              :style="{ backgroundImage: `url(${icon || defaultIcon})` }"
              @click="handleClickChangeImage(2)"
            >
              <span>替换</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabbar-edit-ft">
      <el-button
        size="mini"
        @click="handleCloseEdit(false)"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        size="mini"
        @click="handleCloseEdit(true)"
      >
        确定
      </el-button>
    </div>

    <SpImageSelect
      :image-visible="showImgPicker"
      :choose-one="true"
      @closeImageDialog="onClosePicker"
      @chooseImage="onChangePicker"
    />
  </div>
</template>

<script>
export default {
  name: 'TabbarEdit',
  props: {
    value: Object
  },
  data () {
    const { label, icon, iconHighlight, defaultHighIcon, defaultIcon } = this.value
    return {
      label,
      icon,
      iconHighlight,
      showImgPicker: false,
      iconIndex: 1,
      defaultHighIcon,
      defaultIcon
    }
  },
  methods: {
    handleCloseEdit (type) {
      if (type) {
        if (this.label.length == 0) return this.$message.error('导航名称不能为空!')
        // merge
        this.value.label = this.label
        this.value.icon = this.icon
        this.value.iconHighlight = this.iconHighlight
      }
      this.$emit('input', null)
    },
    handleClickChangeImage (index) {
      this.iconIndex = index
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        if (this.iconIndex == 1) {
          this.iconHighlight = data[0].image_url
        } else {
          this.icon = data[0].image_url
        }
      }
      this.$emit('input', this.value)
    },
    //恢复默认
    reInitVal (type) {
      if (!type) return
      this.$confirm('请确认是否要恢复默认配置', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.label = this.value.default
        this.icon = this.defaultIcon
        this.iconHighlight = this.defaultHighIcon
        return this.$emit('reInitVal', true)
      })
    }
  }
}
</script>
